import { render, staticRenderFns } from "./PageYourDataIsSafe.vue?vue&type=template&id=f2e6ee08"
import script from "./PageYourDataIsSafe.vue?vue&type=script&lang=js"
export * from "./PageYourDataIsSafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports